import * as ActionType from "../actionType";
import { fetchEventApi } from "../../services/page/event";

const getEventAction = () => {
  return async dispatch => {
    dispatchEvent(dispatch);
  };
};

const dispatchEvent = dispatch => {
  fetchEventApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_EVENT,
      data
    });
  });
};

export { getEventAction, dispatchEvent };



// WEBPACK FOOTER //
// ./src/actions/page/event.js